import { StyleSheet } from "react-native-web";
import { vw } from "../../../utils/tool/vw";
import { $darkGray, $midnightGray, $white } from "../../constants/style";

// Mobile-only. Every size goes through vw(), which is capped at a 450px phone
// and evaluated once at module load, so these must never be used on desktop.
export const inlineStyles = StyleSheet.create({
  container: {
    width: "100%",
    flex: 1,
    display: "flex",
    color: $white,
    flexDirection: "column",
    justifyContent: "space-between",
    marginLeft: vw(-4),
    position: "relative",
  },
  headerMenu: {
    paddingLeft: vw(20),
    paddingRight: vw(20),
    paddingTop: vw(15),
    paddingBottom: vw(20),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    gap: vw(10),
  },
  headerMenuTitle: {
    color: $white,
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: vw(22),
    letterSpacing: -0.32,
  },
  item: {
    display: "flex",
    flexDirection: "row",
    gap: vw(4),
    color: $white,
    padding: vw(8),
    paddingLeft: vw(12),
    paddingRight: vw(12),
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: vw(3),
    borderRadius: 999,
    backgroundColor: $darkGray,
    cursor: "pointer",
  },
  activeItem: {
    backgroundColor: "#E6DCC8",
  },
  categoryRowDesktop: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginLeft: vw(5),
    zIndex: 40,
  },

  ItemText: {
    color: $white,
    fontSize: vw(15),
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: vw(20),
    letterSpacing: -0.24,
  },
  ActiveItemText: {
    color: $darkGray,
  },
  communicationButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: vw(8),
    paddingLeft: vw(12),
    paddingRight: vw(12),
    borderRadius: 999,
    backgroundColor: $midnightGray,
    gap: vw(5),
  },
  ItemCall: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: vw(8),
    paddingLeft: vw(12),
    paddingRight: vw(12),
    backgroundColor: $white,
    borderRadius: 999,
    gap: vw(5),
  },
});
